import script from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryItem.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryItem.vue?vue&type=style&index=0&id=5b605a55&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b605a55"]])

export default __exports__